module.exports = __webpack_public_path__ + "12150192fa3fa20c1771b2c15291178e.jpg";